(function () {
  function cartAddUrl() {
    return (window.__glowRoutes && window.__glowRoutes.cartUrl ? window.__glowRoutes.cartUrl : "/cart") + "/add.js";
  }

  function addToCart(variantId, quantity) {
    return fetch(cartAddUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 }),
    }).then(function (res) {
      if (!res.ok) throw new Error("Failed to add to cart");
      return res.json();
    });
  }

  function initPressureWasher(section) {
    if (!section || section.dataset.pressureReady === "true") return;
    section.dataset.pressureReady = "true";

    section.querySelectorAll("[data-pressure-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;

        var kitSection = document.querySelector("[data-complete-kit]");
        var index = btn.getAttribute("data-kit-index");
        var variantId = btn.getAttribute("data-variant-id");

        // Prefer complete-kit modal when that section exists on the page
        if (kitSection) {
          document.dispatchEvent(
            new CustomEvent("complete-kit:open", {
              detail: {
                index: index != null ? Number(index) : null,
                variantId: variantId ? Number(variantId) : null,
              },
            })
          );
          return;
        }

        if (!variantId) return;

        var originalHtml = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = "Adding...";

        addToCart(variantId, 1)
          .then(function () {
            document.dispatchEvent(
              new CustomEvent("cart:refresh", { detail: { openDrawer: true } })
            );
          })
          .catch(function (error) {
            console.error("Pressure washer add to cart error:", error);
          })
          .finally(function () {
            btn.disabled = false;
            btn.innerHTML = originalHtml;
          });
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-pressure-washer]").forEach(initPressureWasher);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    initAll(event.target);
  });
})();
